import React, { useEffect } from 'react';
import { Router, Switch, Route } from 'react-router-dom';
import ShareScreen from '@common/screens/ShareScreen';
import RenderScreen from '@common/screens/RenderScreen';
import history from './history';
import ShareLink from '@common/screens/ShareLink';
import ShareScreenModal from '@common/screens/ShareScreenModal';
import ShareScreenUrl from '@common/screens/ShareScreenUrl';

export default function AppRoutes() {
  useEffect(() => {
    // Listen for the response
    window.addEventListener('message', function (event) {
      try {
        // Verify the origin of the message
        if (event?.data?.type === 'click__get__cookie') {
          const cookie = event.data.cookie;
          console.log('=== Cookie received:', cookie);
          localStorage.setItem('click__cookie', cookie);
        }
        if (event?.data?.type === 'click__get__current_url') {
          const currentUrl = event.data.currentUrl;
          console.log('=== currentUrl received:', currentUrl);
          localStorage.setItem('click__current_url', currentUrl);
        }
      } catch (error) {
        console.error('=== error', error);
        // do nothing
      }
    });
  }, []);

  return (
    <Router history={history}>
      <Switch>
        <Route path="/share/:shortUrl" component={ShareLink} />
        <Route exact path="/" component={ShareScreen} />
        <Route path="/preview/:appId" component={RenderScreen} />
        <Route path="/share-modal/:appId" component={ShareScreenModal} />
        <Route path="/share-app/:appId" component={ShareScreenUrl} />
        <Route path="/:appId" component={ShareScreen} />
      </Switch>
    </Router>
  );
}
